import store from "../state/store"

// export const resourceList = {
//     dashboard: "/dashboard",
//     dashboard_appointments: "/dashboard/appointments",
//     dashboard_appointments_create: "/dashboard/appointments/create",
//     dashboard_tasks: "/dashboard/tasks",
//     dashboard_tasks_task_edit: "/dashboard/tasks/task/edit",
//     dashboard_tasks_task_delete: "/dashboard/tasks/task/delete",
//     dashboard_tasks_addTask: "/dashboard/tasks/addTask",
//     dashboard_graphs: "/dashboard/graphs",
//     dashboard_graphs_appointmentsReport: "/dashboard/graphs/appointmentsReport",
//     dashboard_graphs_productivityReport: "/dashboard/graphs/productivityReport",
//     clients: "/clients",
//     clients_addClients: "/clients/addClients",
//     clients_uploadclients: "/clients/uploadClients",
//     clients_active: "/clients/active",
//     clients_archive: "/clients/archive",
//     clients_active_view: "/clients/active/view",
//     cients_active_archive: "clients/active/archive",
//     clients_archive_activate: "/clients/archive/activate",
//     clients_client_editclient: "/clients/client/editclient",
//     clients_client_billingTimer: "/clients/client/billingTimer",
//     clients_client_addCreditCard: "/clients/client/addCreditCard",
//     clients_client_editCreditCard: "/clients/client/editCreditCard",
//     clients_client_deleteCreditCard: "/clients/client/deleteCreditCard",
//     clients_client_overview: "/clients/client/overview",
//     clients_client_overview_pendingSection:
//         "/clients/client/overview/pendingSection",
//     clients_client_overview_reportOfFindings:
//         "/clients/client/overview/reportOfFindings",
//     clients_client_overview_treatmentPlanProgress:
//         "/clients/client/overview/TreatmentPlanProgress",
//     clients_client_assessment: "/clients/client/assessment",
//     clients_client_assessment_createAssessment:
//         "/clients/client/assessment/createAssessment",
//     clients_client_assessment_uploadAssessment:
//         "/clients/client/assessment/uploadAssessment",
//     clients_client_assessment_editTest: "/clients/client/assessment/editTest",
//     clients_client_assessment_viewTest: "/clients/client/assessment/viewTest",
//     clients_client_assessment_takeTest: "/clients/client/assessment/takeTest",
//     clients_client_assessment_deleteTest:
//         "/clients/client/assessment/deleteTest",
//     clients_client_assessment_sdohGraph: "/clients/client/assessment/sdohGraph",
//     clients_client_assessment_phq9Graph: "/clients/client/assessment/phq9Graph",
//     clients_client_assessment_gad7Graph: "/clients/client/assessment/gad7Graph",
//     clients_client_assessment_pssGraph: "/clients/client/assessment/pssGraph",
//     clients_client_assessment_rseGraph: "/clients/client/assessment/rseGraph",
//     clients_client_assessment_alcoholGraph:
//         "/clients/client/assessment/alcoholGraph",
//     clients_client_assessment_mdqGraph: "/clients/client/assessment/mdqGraph",
//     clients_client_assessment_outcomeGraph:
//         "/clients/client/assessment/outcomeGraph",
//     clients_client_careplan: "/clients/client/careplan",
//     clients_client_careplan_createCarePlan:
//         "/clients/client/careplan/createCarePlan",
//     clients_client_careplan_createActivities:
//         "/clients/client/careplan/createActivities",
//     clients_client_careplan_bulkUpdate: "/clients/client/careplan/bulkUpdate",
//     clients_client_notes: "/clients/client/notes",
//     clients_client_notes_addNotes: "/clients/client/notes/addNotes",
//     clients_client_notes_downloadNotes: "/clients/client/notes/downloadNotes",
//     clients_client_notes_editNote: "/clients/client/notes/editNote",
//     clients_client_appointments: "/clients/client/appointments",
//     clients_client_appointments_createAppointment:
//         "/clients/client/appointments/createAppointment",
//     clients_client_appointments_appointment_reschedule:
//         "/clients/client/appointments/appointmnent/reschedule",
//     clients_client_appointments_appointment_cancel:
//         "/clients/client/appointments/appointmnent/cancel",
//     clients_client_resources: "/clients/client/resources",
//     clients_client_activityLog: "/clients/client/activityLog",
//     clients_client_activityLog_downloadActivityLogReport:
//         "/clients/client/activityLog/downloadActivityLogReport",
//     clients_client_callSummary: "/clients/client/callSummary",
//     clients_client_callSummary_teleHealth:
//         "/clients/client/callSummary/teleHealth",
//     clients_client_callSummary_inPerson: "/clients/client/callSummary/inPerson",
//     appointments: "/dashboard/appointments",
//     appointments_createAppointment: "/dashboard/appointments/createAppointment",
//     appointments_upcomingAppointment:
//         "/dashboard/appointments/upcomingAppointment",
//     appointments_completedAppointment:
//         "/dashboard/appointments/completedAppointment",
//     appointments_cancelledAppointment:
//         "/dashboard/appointments/cancelledAppointment",
//     callLogs: "/dashboard/callLogs",
//     callLogs_all: "/dashboard/callLogs/all",
//     callLogs_inbound: "/dashboard/callLogs/inbound",
//     callLogs_outbound: "/dashboard/callLogs/outbound",
//     callLogs_missed: "/dashboard/callLogs/missed",
//     callLogs_marketing: "/dashboard/callLogs/marketing",
//     reports: "/dashboard/reports",
//     reports_consentReport: "/dashboard/reports/consentReport",
//     reports_appointmentsReport: "/dashboard/reports/appointmentsReport",
//     reports_bhnTimeSpentReport: "/dashboard/reports/bhnTimeSpentReport",
//     reports_carePerformanceReport: "/dashboard/reports/carePerformanceReport",
//     reports_revenueReport: "/dashboard/reports/revenueReport",
//     reports_carePlanReport: "/dashboard/reports/carePlanReport",
//     reports_moodAssessmentReport: "/dashboard/reports/moodAssessmentReport",
//     resources: "/dashboard/resources",
//     documents: "/dashboard/documents",
//     documents_addDoc: "/dashboard/documents/addDoc",
//     documents_status: "/dashboard/document/status",
//     invoices: "/dashboard/invoices",
//     invoices_viewInvoice: "/dashboard/invoices/viewInvoice",
//     summary: "/dashboard/summary",
//     summary_viewSummary: "/dashboard/summary/viewSummary",
//     notifications: "/dashboard/notifications",
//     messageCenter: "/dashboard/messageCenter",
//     orgDropDown: "orgDropdown",
//     clinicDropDown: "clinicDropdown",
//     manage: "/dashboard/manage",
//     organizations: "/dashboard/manage/organizations",
//     organizations_addOrg: "/dashboard/manage/organizations/addOrg",
//     organizations_organization_editOrg:
//         "/dashboard/manage/organizations/organization/editOrg",
//     organizations_organization_addClinic:
//         "/dashboard/manage/organizations/organization/addClinic",
//     organizations_organization_clinics:
//         "/dashboard/manage/organizations/organization/clinics",
//     organizations_organization_users:
//         "/dashboard/manage/organizations/organization/users",
//     organizations_organization_addUser:
//         "/dashboard/manage/organizations/organization/addUser",
//     organizations_organization_clinic_editClinic:
//         "/dashboard/manage/organizations/organization/clinic/editClinic",
//     organizations_organization_clinic_addUser:
//         "/dashboard/manage/organizations/organization/clinic/addUser",
//     // organizations: "/dashboard/organizations",
//     // organizations_addOrg: "/dashboard/organizations/addOrg",
//     // organizations_organization_editOrg:
//     //   "/dashboard/organizations/organization/editOrg",
//     // organizations_organization_addClinic:
//     //   "/dashboard/organizations/organization/addClinic",
//     // organizations_organization_clinics:
//     //   "/dashboard/organizations/organization/clinics",
//     // organizations_organization_users:
//     //   "/dashboard/organizations/organization/users",
//     // organizations_organization_addUser:
//     //   "/dashboard/organizations/organization/addUser",
//     organizations_organization_editUser:
//         "/dashboard/manage/organizations/organization/editUser",
//     organizations_organization_editUser_deleteUser:
//         "/dashboard/manage/organizations/organization/editUser/deleteUser",
//     // organizations_organization_clinic_editClinic:
//     //   "/dashboard/organizations/organization/clinic/editClinic",
//     // organizations_organization_clinic_addUser:
//     //   "/dashboard/organizations/organization/clinic/addUser",
//     organizations_organization_clinic_editUser:
//         "/dashboard/manage/organizations/organization/clinic/editUser",
//     organizations_organization_clinic_editUser_deleteUser:
//         "/dashboard/manage/organizations/organization/clinic/editUser/deleteUser",
//     consent_overview: "/consent/overview",
//     consent_notes: "/consent/notes",
//     carecall_overview: "/carecall/overview",
//     carecall_careplan: "/carecall/careplan",
//     carecall_notes: "/carecall/notes",
//     clients_client_appointments_makePayment:
//         "/clients/client/appointments/makePayment",
//     clients_client_messageCenter: "/clients/client/messageCenter",
//     messageCenter_bulkSms: "/dashboard/messageCenter/bulkSms",
//     user_consultationFees:
//         "/dashboard/userProfile/settingsPreferences/consultationFees",
//     postCall_addNotes: "/dashboard/postCall/addNotes",
//     postCall_edit: "/dashboard/postCall/editNotes",
//     summary_pending: "/dashboard/summary/pending",
//     summary_viewclient: "/dashboard/summary/viewclient",
//     summary_clientSummary_approve: "/dashboard/summary/clientSummary/approve",
//     summary_clientSummary_reject: "/dashboard/summary/clientSummary/reject",
//     summary_clientSummary_share_via_email:
//         "/dashboard/summary/clientSummary/shareViaEmail",
//     summary_clientSummary_download: "/dashboard/summary/clientSummary/download",
//     playground: "/dashboard/manage/aiplayground",
//     clients_client_regenerateSummary: "/clients/client/regenerateSummary",
//     summary_clientSummary_editProfile:
//         "/dashboard/summary/clientSummary/editProfile",
//     summary_clientSummary_editAssessments:
//         "/dashboard/summary/clientSummary/editAssessments",
//     summary_clientSummary_editCarePlan:
//         "/dashboard/summary/clientSummary/editCarePlan",
//     summary_clientSummary_editNotes:
//         "/dashboard/summary/clientSummary/editNotes",
// }
export const resourceList = {}

export const checkAccess = (accessFor, resourceList = null) => {
    // Return false during SSR to prevent window-dependent components from rendering
    if (typeof window === "undefined") {
        return false
    }
    return true
    // let resources = resourceList || store.getState().login.resources
    // let returnBool = false
    // if (resources.length > 0) {
    //     returnBool = resources.includes(accessFor)
    // } else {
    //     returnBool = false
    // }
    // return returnBool
}
